import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { TranslationService } from 'src/app/services/translation.service';
import { AccountService } from '../account.service';
import * as CryptoJS from 'crypto-js';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  providers: [TranslationService]
})
export class ForgotPasswordComponent implements OnInit {
  timerText = '';
  form!: FormGroup;
  otpSent: boolean = false;
  key = CryptoJS.enc.Utf8.parse("contractorPortal"); // 256-bit key (32 characters)
  salt = { "words": [130332099, 3412898925, 4080727054, 1733911705], "sigBytes": 16 };
  isTimerEnable: boolean = false
  constructor(private fb: FormBuilder, private accountService: AccountService,private router: Router, public snackbarService: SnackbarService) { }

  ngOnInit(): void {
    this.buildForm()
  }
  buildForm() {
    this.form = this.fb.group({
      username: ['', Validators.required],
      otp: ['']
    })
  }

  getOtp() {
    let business = sessionStorage.getItem('Business')
    this.form?.get('username')?.markAsTouched();
    if (this.form.valid) {
      let req = {
        username: this.form?.get('username')?.value,
        business: business
      }
      
      this.accountService.generateForgetOTP(req).subscribe((data:any) => {
         if(data['status'] == 200){
          this.startCountdown()
          this.isTimerEnable = true
          this.otpSent = true;
          this.form?.get('otp')?.setValue('');
         }else{
           this.openSnackbar(data['message']);
         }
      }
        , error => {
          let message = error.error || error.error[0];
          this.openSnackbar(message.message);
        })
    } else {
      this.openSnackbar('Please validate the form');
    }
  }
  encryptMessage(message:any, key:any) {
    const keySize = 512; // 256 bits
    const iterations = 1000;

    const encrypted = CryptoJS.AES.encrypt(message, key, {
      keySize: keySize / 16,
      //iv: salt,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iterations: iterations
    });

    return encrypted.toString();
  }
  
  encodeSalt(str: string,key:string) {   
    const ciphertext = this.encryptMessage(str, key);
    //return btoa(ciphertext);
    return btoa(ciphertext);
  }
  submit(){
    if(!this.otpSent){
      return
    }
    this.form?.get('otp')?.setValidators(Validators.required);
    this.form?.get('otp')?.updateValueAndValidity();
    if (this.form.valid) {      
      let req = this.form.value
      

      let saltReq = {
        username: this.form.value.username
      }
      this.accountService.getCommonOtpSalt(saltReq).subscribe((dataSalt:any) => {
        if (dataSalt['status'] == 200) {
          req.otp = this.encodeSalt(req.otp,dataSalt['salt']);
          this.accountService.verifyForgetOTP(req).subscribe((data:any) => {
          if(data['message'] == 'OTP verified successfully'){
            this.router.navigate(['/auth/new-password']);
            sessionStorage.setItem('username', JSON.stringify(this.form?.get('username')?.value));
          }else{
           this.openSnackbar(data['message']);
         }
      }
        , error => {
          let message = error.error || error.error[0];
          this.openSnackbar(message.error);
        })
        }

      }
        , error => {
          let message = error.error || error.error[0];
          this.openSnackbar(message.error);
        })
      
    }
  }
   /**
* open toaster for showing message 
*/
openSnackbar(message: string) {
  this.snackbarService.open(message);
}
startCountdown() {
  var counter = 60 * 2;

  var interval = setInterval(() => {
    sessionStorage.setItem('timer', counter + '')
    let minutes = Math.floor((counter % 3600) / 60);
    let seconds = Math.floor(counter % 60);
    let minute = minutes < 10 ? "0" + minutes : minutes;
    let second = seconds < 10 ? "0" + seconds : seconds;
    this.timerText = minute + ":" + second;
    counter--;
    if (counter < 0) {
     
      // The code here will run when
      // the timer has reached zero.
      clearInterval(interval);
      this.timerText = "00:00";
      this.isTimerEnable = false;
      this.otpSent = false
    };
  }, 1000);
}

goBack(){
  this.router.navigate(['/auth/login'])
}

}

